import React from "react";
import Servis21 from "./components/servis21";
import DpdShips from "./components/dpd_ships";
export default class Cariers extends React.Component {
    state={
        selectGroup: 0,
        groups: [
            {
              title: "Servis21 zásilky",
              key: 0
            },
            {
              title: "DPD-CZ Rozvozy",
              key: 1
            },
            {
                title: "DPD-SK Rozvozy",
                key: 2
              },
              {
                title: "DPD-CZ Svozy",
                key: 3
              }
          ]
    }

    componentDidMount() {
        const {Icon} = this.props;
        this.props.setHeaderPage({
          Icon: <Icon facodebranch className="c-placeholder c-green" />,
          Title: "Přepravci",
          SubTitle: "Integrace se všemi dopravci (DPD-CZ / DPD-SK)",
        });
      }
    
    render() {
        const { Bs, VARIANT } = this.props;
        return (
            <>
            <Bs row className="mb-4">
          <Bs
            nav
            variant={VARIANT.TABS}
            className="c-tab"
            defaultActiveKey={this.state.selectGroup}
          >
            {this.state.groups.map(e => (
              <Bs navitem>
                <Bs
                  navlink
                  onClick={() => this.setState({ selectGroup: e.key })}
                  eventKey={e.key}
                >
                  {e.title}
                </Bs>
              </Bs>
            ))}
          </Bs>
        </Bs>
        {this.state.selectGroup === 0 && (<Servis21 {...this.props} />)}
        {this.state.selectGroup === 1 && (<DpdShips {...this.props} />)}
        </>
        );
    }
}